import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateServiceSwitchActive = {
  serviceSwitchActive: { data: null, loading: false, error: null },
};

export const serviceSwitchActive = createAsyncThunk('user/serviceSwitchActive', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/service/switch-active`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerServiceSwitchActive = {
  [serviceSwitchActive.pending]: (state) => {
    state.serviceSwitchActive.loading = true;
  },
  [serviceSwitchActive.fulfilled]: (state, action) => {
    state.serviceSwitchActive.loading = false;
    state.serviceSwitchActive.data = action.payload;
    state.serviceSwitchActive.error = null;
  },
  [serviceSwitchActive.rejected]: (state, action) => {
    state.serviceSwitchActive.loading = false;
    state.serviceSwitchActive.error = action.payload;
  },
};
